<template>
  <div>
    <div class="container__table">
      <h3>{{ $t("users.title") }}</h3>
      <a @click="inviteUser()" class="button-float"><i class="material-icons">person_add</i></a>
      <div class="new-search">
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th>{{ $t("users.firstname") }}</th>
                <th>{{ $t("users.lastname") }}</th>
                <th>{{ $t("users.email") }}</th>
                <th>{{ $t("users.status") }}</th>
                <th>{{ $t("users.actions") }}</th>
              </tr>
            </thead>
            <tbody v-if="loadedData">
              <tr v-for="usr in users" :key="usr.id">
                <td>{{ usr.firstName }}</td>
                <td>{{ usr.lastName }}</td>
                <td>{{ usr.email }}</td>
                <td>{{ $t(`users.statusCode.${usr.status}`) }}</td>
                <td class="table-container__actions">
                  <!-- <a v-if="usr.type == 1" @click="editUser(usr.objectId)"><i class="material-icons">edit</i></a> -->
                  <a v-if="usr.type == 'User' && user.id != usr.objectId" @click="openModalConfirmUserDelete(usr.objectId)"><i class="material-icons">delete</i></a>

                  <a v-if="usr.type == 'Invitation'" @click="openModalConfirmResendInvite(usr.objectId)"><i class="material-icons">forward_to_inbox</i></a>
                  <a v-if="usr.type == 'Invitation'" @click="openModalConfirmInviteDelete(usr.objectId)"><i class="material-icons">delete</i></a>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="index in 3" :key="index">
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
                  <td><Skeletor width="100%" height="24"/></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ModalSendInvite v-if="activeModalSendInvite" @close="closeModalInvite" @sended="reloadData"/>
    <ModalEdit v-if="activeModalEdit" @close="closeModalEdit"/>
    <ModalConfirmDelete v-if="activeModalConfirmDelete" :userId="userSelectedId" @close="closeModalConfirmDelete" @confirm="reloadData"/>
    <ModalConfirmResendInvite v-if="activeModalConfirmResendInvite" :inviteId="invitationSelectedId" @close="closeModalConfirmResendInvite" @confirm="reloadData"/>
    <ModalConfirmDeleteInvite v-if="activeModalConfirmInviteDelete" :inviteId="invitationSelectedId" @close="closeModalConfirmInviteDelete" @confirm="reloadData"/>

  </div>
</template> 
<script>
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
//import { useRouter } from 'vue-router';
import ModalSendInvite from '@/components/Users/ModalSendInvite';
import ModalEdit from '@/components/Users/ModalEdit';
import ModalConfirmDelete from '@/components/Users/ModalConfirmDelete';
import ModalConfirmResendInvite from '@/components/Users/ModalConfirmResendInvite';
import ModalConfirmDeleteInvite from '@/components/Users/ModalConfirmDeleteInvite';

import { Skeletor } from 'vue-skeletor';

export default {
  components: {
    ModalSendInvite,
    ModalEdit,
    ModalConfirmDelete,
    ModalConfirmResendInvite,
    ModalConfirmDeleteInvite,
    Skeletor
  },
  setup() {
    const store = useStore();
    const users = ref([]);
    //const router = useRouter()
    const activeModalSendInvite = ref(false);
    const activeModalEdit = ref(false);
    const activeModalConfirmDelete = ref(false);
    const activeModalConfirmInviteDelete = ref(false);
    const activeModalConfirmResendInvite = ref(false);
    const user = computed(() => store.getters.manageUser_user);
    const { t } = useI18n();
    const loadedData = ref(false)
    onMounted(async () => {
      await loadData()
    });

    async function loadData(){
      loadedData.value = false
      try {
        const data =  await store.dispatch('users_search', { filter: '', pageNumber: 0, rowsPerPage:300 });
        users.value = data;
        loadedData.value = true

      } catch (e) {
        store.dispatch('notifications_create', { text: t(`notifications.generic`) });
      }
    }

    function closeModalInvite() { activeModalSendInvite.value = false }
    function inviteUser () { activeModalSendInvite.value = true }

    function closeModalEdit() { activeModalEdit.value = false }
    function editUser () {
      activeModalEdit.value = true
    }

    const userSelectedId = ref(0)
    function closeModalConfirmDelete() { activeModalConfirmDelete.value = false }
    async function openModalConfirmUserDelete (userId) { 
      userSelectedId.value = userId
      activeModalConfirmDelete.value = true
    }

    const invitationSelectedId = ref(0)
    function closeModalConfirmInviteDelete() { activeModalConfirmInviteDelete.value = false }
    function openModalConfirmInviteDelete(invitationId) { 
      invitationSelectedId.value = invitationId
      activeModalConfirmInviteDelete.value = !activeModalConfirmInviteDelete.value 
    }
    async function reloadData () { await loadData() }

    
    function closeModalConfirmResendInvite() { activeModalConfirmResendInvite.value = false }
    function openModalConfirmResendInvite(invitationId) { 
      invitationSelectedId.value = invitationId
      activeModalConfirmResendInvite.value = !activeModalConfirmResendInvite.value 
    }
    
    return {
      loadedData,
      user,
      users,
      activeModalSendInvite,
      closeModalInvite,
      activeModalEdit,
      closeModalEdit,
      
      inviteUser,
      editUser,

      userSelectedId,
      activeModalConfirmDelete,
      closeModalConfirmDelete,
      openModalConfirmUserDelete,

      invitationSelectedId,
      activeModalConfirmResendInvite,
      closeModalConfirmResendInvite,
      openModalConfirmResendInvite,

      activeModalConfirmInviteDelete,
      closeModalConfirmInviteDelete,
      openModalConfirmInviteDelete,

      reloadData
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~vue-skeletor/dist/vue-skeletor.css';
  .container {
    padding: 0 $margin-base;

    @media (min-width: $break-sm) {
      padding: 0;
    }

    @media (min-width: $break-md) {
      padding: 0 $margin-base;
    }

    @media (min-width: $break-lg) {
      padding: 0;
    }
  }

  .new-search {

    table {
      min-width: 830px;
    }

    tr {
      display: grid;
      grid-template-columns: repeat(5, minmax(0, 1fr));
      gap: $margin-milli;

      td {
        word-break: break-all;
      }
    }
  }
</style>